// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorRoleTypeModel {
    static getAttributeTypeMap() {
        return PayorRoleTypeModel.attributeTypeMap;
    }
}
PayorRoleTypeModel.discriminator = undefined;
PayorRoleTypeModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    }
];
//# sourceMappingURL=payorRoleTypeModel.js.map